import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as sessionService from '../services/sessionService';
import { useTheme } from '../contexts/ThemeContext';

export const NewSession: React.FC = () => {
  const [prompt, setPrompt] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { darkMode } = useTheme();
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!prompt.trim()) {
      setError('Please enter a prompt');
      return;
    }
    
    setIsSubmitting(true);
    setError(null);
    
    try {
      const result = await sessionService.createSession(prompt);
      
      // Check for redirect parameter
      const params = new URLSearchParams(window.location.search);
      const redirect = params.get('redirect');
      
      if (redirect === 'artifactory') {
        navigate(`/artifactory/${result.session_id}`);
      } else {
        navigate(`/sessions/${result.session_id}`);
      }
    } catch (err: any) {
      setError(err.message || 'Failed to create session');
      setIsSubmitting(false);
    }
  };
  
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Create New Session</h1>
      
      <form onSubmit={handleSubmit} className="max-w-2xl mx-auto">
        <div className="mb-4">
          <label htmlFor="prompt" className={`block text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
            What would you like to work on?
          </label>
          <textarea
            id="prompt"
            rows={5}
            className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
              darkMode 
                ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
            }`}
            placeholder="Enter your prompt here..."
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            disabled={isSubmitting}
          />
        </div>
        
        {error && (
          <div className={`mb-4 p-3 rounded-md ${
            darkMode 
              ? 'bg-red-900 bg-opacity-20 text-red-400 border border-red-800' 
              : 'bg-red-100 text-red-700'
          }`}>
            {error}
          </div>
        )}
        
        <div className="flex justify-end">
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:bg-gray-400"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Creating...' : 'Create Session'}
          </button>
        </div>
      </form>
    </div>
  );
};
